export const isScrolledNearBottom = (target, threshold = 48) => {
  const { scrollTop, scrollHeight, clientHeight } = target;
  return scrollHeight - scrollTop - clientHeight < threshold;
};

export default isScrolledNearBottom;
